const STATIC_BASE = process.env.SEARCH_STATIC_BASE

export default {
  AUDIO: {
    name: 'Audio',
    image: STATIC_BASE + 'img/audio.svg'
  },
  GAME: {
    name: 'Mini-Spiel',
    image: STATIC_BASE + 'img/game.svg'
  },
  QUIZ: {
    name: 'Quiz',
    image: STATIC_BASE + 'img/quiz.svg'
  },
  INTERACTIVE: {
    name: 'Interaktiv',
    image: STATIC_BASE + 'img/interactive.svg'
  },
  PDF: {
    name: 'PDF',
    image: STATIC_BASE + 'img/document.svg'
  },
  VIDEO: {
    name: 'Video',
    image: STATIC_BASE + 'img/video.svg'
  },
  METHOD: {
    name: 'Methode',
    image: STATIC_BASE + 'img/method.svg'
  },
  EXPERIMENT: {
    name: 'Experiment',
    image: STATIC_BASE + 'img/experiment.svg'
  }
}
